export const GET_CLOVER_SETTINGS_STARTED = "GET_CLOVER_SETTINGS_STARTED"
export const GET_CLOVER_SETTINGS_SUCCESS = "GET_CLOVER_SETTINGS_SUCCESS"
export const GET_CLOVER_SETTINGS_FAILURE = "GET_CLOVER_SETTINGS_FAILURE"

export const UPDATE_CLOVER_SETTINGS_STARTED = "UPDATE_CLOVER_SETTINGS_STARTED"
export const UPDATE_CLOVER_SETTINGS_SUCCESS = "UPDATE_CLOVER_SETTINGS_SUCCESS"
export const UPDATE_CLOVER_SETTINGS_FAILURE = "UPDATE_CLOVER_SETTINGS_FAILURE"

export const LOG_IN_CLOVER_STARTED = "LOG_IN_CLOVER_STARTED"
export const LOG_IN_CLOVER_SUCCESS = "LOG_IN_CLOVER_SUCCESS"
export const LOG_IN_CLOVER_FAILURE = "LOG_IN_CLOVER_FAILURE"

export const CREATE_CLOVER_PAYMENT_STARTED = "CREATE_CLOVER_PAYMENT_STARTED"
export const CREATE_CLOVER_PAYMENT_SUCCESS = "CREATE_CLOVER_PAYMENT_SUCCESS"
export const CREATE_CLOVER_PAYMENT_FAILURE = "CREATE_CLOVER_PAYMENT_FAILURE"

export const CREATE_TIP_REQUEST_STARTED = "CREATE_TIP_REQUEST_STARTED"
export const CREATE_TIP_REQUEST_SUCCESS = "CREATE_TIP_REQUEST_SUCCESS"
export const CREATE_TIP_REQUEST_FAILURE = "CREATE_TIP_REQUEST_FAILURE"

export const DISPLAY_RECEIPT_OPTION_STARTED = "DISPLAY_RECEIPT_OPTION_STARTED"
export const DISPLAY_RECEIPT_OPTION_SUCCESS = "DISPLAY_RECEIPT_OPTION_SUCCESS"
export const DISPLAY_RECEIPT_OPTION_FAILURE = "DISPLAY_RECEIPT_OPTION_FAILURE"



export const PRINT_CLOVER_RECEIPT_STARTED = "PRINT_CLOVER_RECEIPT_STARTED"
export const PRINT_CLOVER_RECEIPT_SUCCESS = "PRINT_CLOVER_RECEIPT_SUCCESS"
export const PRINT_CLOVER_RECEIPT_FAILURE = "PRINT_CLOVER_RECEIPT_FAILURE"

export const DISPLAY_WELCOME_MESSAGE_STARTED = "DISPLAY_WELCOME_MESSAGE_STARTED"
export const DISPLAY_WELCOME_MESSAGE_SUCCESS = "DISPLAY_WELCOME_MESSAGE_SUCCESS"
export const DISPLAY_WELCOME_MESSAGE_FAILURE = "DISPLAY_WELCOME_MESSAGE_FAILURE"

export const CHECK_DEVICE_CONNECTION_STARTED = "CHECK_DEVICE_CONNECTION_STARTED"
export const CHECK_DEVICE_CONNECTION_SUCCESS = "CHECK_DEVICE_CONNECTION_SUCCESS"
export const CHECK_DEVICE_CONNECTION_FAILURE = "CHECK_DEVICE_CONNECTION_FAILURE"

export const SWITCH_CONNECTION_STARTED = "SWITCH_CONNECTION_STARTED"
export const SWITCH_CONNECTION_SUCCESS = "SWITCH_CONNECTION_SUCCESS"
export const SWITCH_CONNECTION_FAILURE = "SWITCH_CONNECTION_FAILURE"

export const SET_DEFAULT_DEVICE_CLOVER_STARTED = "SET_DEFAULT_DEVICE_CLOVER_STARTED"
export const SET_DEFAULT_DEVICE_CLOVER_SUCCESS = "SET_DEFAULT_DEVICE_CLOVER_SUCCESS"
export const SET_DEFAULT_DEVICE_CLOVER_FAILURE = "SET_DEFAULT_DEVICE_CLOVER_FAILURE"

export const DISCONNECT_CLOVER_DEVICES_STARTED = "DISCONNECT_CLOVER_DEVICES_STARTED"
export const DISCONNECT_CLOVER_DEVICES_SUCCESS = "DISCONNECT_CLOVER_DEVICES_SUCCESS"
export const DISCONNECT_CLOVER_DEVICES_FAILURE = "DISCONNECT_CLOVER_DEVICES_FAILURE"

export const RESET_STATUS = "RESET_STATUS"

export const LOG_OUT_CLOVER = "LOG_OUT_CLOVER"
export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"
